import ReactConfetti from 'react-confetti'
import { IConfettiOptions } from 'react-confetti/dist/types/Confetti'

export const Confetti = ({
  recycle = false,
  numberOfPieces = 400,
  gravity = 0.2,
  ...rest
}: Partial<IConfettiOptions>) => (
  <ReactConfetti
    style={{ zIndex: 340 }}
    {...rest}
    recycle={recycle}
    gravity={gravity}
    numberOfPieces={numberOfPieces}
  />
)
